const user = {
  displayName: "",
  identity: "",
  mailboxes: []
};

export default user;
